<app-header *ngIf="this.infoUserLogin.user"></app-header>

<router-outlet></router-outlet>

<app-footer *ngIf="this.infoUserLogin.user"></app-footer>




